import React from 'react'

const text = props => <div className='error'>
  <div>
    {props.appState.item === 2 ? <p>Error</p> : null}
    <h2>404</h2>
  </div>
</div>

export default text